// extracted by mini-css-extract-plugin
export default {"card":"campaignCardBase--card--WioNu8Zw","statCol":"campaignCardBase--statCol--DAI_l3lh"};